var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { createApolloClient, restartWebsockets } from 'vue-cli-plugin-apollo/graphql-client';
import firebase from 'firebase';
import router from '@/router/index';
import { clearToken } from './user';
import { Notifications } from './notifications';
Vue.use(VueApollo);
var AUTH_TOKEN = 'gm-token';
var HASURA_URI = process.env.HASURA_BASE_URL + "/v1/graphql";
var defaultOptions = {
    httpEndpoint: "https://" + HASURA_URI,
    wsEndpoint: "wss://" + HASURA_URI,
    tokenName: AUTH_TOKEN,
    persisting: false,
    websocketsOnly: true,
    ssr: false,
    cache: null,
    inMemoryCacheOptions: null,
};
var ApolloHandler = /** @class */ (function () {
    function ApolloHandler() {
        this.apolloClient = null;
    }
    ApolloHandler.prototype.createProvider = function () {
        var _this = this;
        var _a;
        var wsClient;
        (_a = createApolloClient(__assign({}, defaultOptions)), this.apolloClient = _a.apolloClient, wsClient = _a.wsClient);
        wsClient.connectionParams = function () {
            return {
                headers: {
                    Authorization: localStorage.getItem(AUTH_TOKEN) ? "Bearer " + localStorage.getItem(AUTH_TOKEN) : ''
                }
            };
        };
        this.apolloClient.wsClient = wsClient;
        // Create vue apollo provider
        var apolloProvider = new VueApollo({
            defaultClient: this.apolloClient,
            errorHandler: function (error) { return __awaiter(_this, void 0, void 0, function () {
                var isJWTError, errorMsg, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(error);
                            console.log('%cError', 'background: red; color: white; padding: 2px 4px; border-radius: 3px; font-weight: bold;', error.message);
                            isJWTError = false;
                            try {
                                errorMsg = error.networkError.message;
                                if (errorMsg.toLowerCase().indexOf('jwt') > -1) {
                                    isJWTError = true;
                                }
                            }
                            catch (e) { }
                            if (!isJWTError) return [3 /*break*/, 5];
                            Notifications.service.open({
                                duration: 5000,
                                message: 'Session expired. Logging out.',
                                position: 'is-top',
                                type: 'is-warning'
                            });
                            this.onAuthChange();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, firebase.auth().signOut()];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            return [3 /*break*/, 4];
                        case 4:
                            clearToken();
                            router.push({ name: 'Login' });
                            setTimeout(function () { return location.reload(); }, 5000); // Just refresh the page so the error doesn't keep propagating
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); },
        });
        return apolloProvider;
    };
    ApolloHandler.prototype.onAuthChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.apolloClient && this.apolloClient.wsClient) {
                            restartWebsockets(this.apolloClient.wsClient);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.apolloClient.cache.reset()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.apolloClient.resetStore()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        console.log('%cError on cache reset', 'color: orange;', e_2.message);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return ApolloHandler;
}());
export var apolloHandler = new ApolloHandler();



//////////////////
// WEBPACK FOOTER
// ./src/services/apollo.ts
// module id = 113
// module chunks = 1